import { PUT_CLIENTI_V1 } from '../../constants/ActionTypes'
import { fetchPutClienti } from '../buy/Clienti'

export const putClientiV1 = (dispatch, getState) => {
  const cliente = getState().customer
  const idOrdine = getState().ordine.id_ordine

  return dispatch(
    fetchPutClienti(PUT_CLIENTI_V1)({
      cliente,
      id_ordine: idOrdine,
      callback: PUT_CLIENTI_V1,
      errorMessage: PUT_CLIENTI_V1,
    })
  )
}
